import styled from 'styled-components';

export const SCDiv = styled.div``;
